import { Link } from 'react-router-dom';
import React from 'react';

export const AssetLink = ({ id, serialNumber, product }) => {
  return (
    <Link to={'/assets/' + id}>
      {product ? product.name : id} {serialNumber && `[${serialNumber}]`}
    </Link>
  );
};
